import React, { useContext } from "react";
import BackGround from "../../assets/AccountDetails/darkBlueBG.png";
import { ReactComponent as User } from "../../assets/AccountDetails/Personal.svg";
import { ReactComponent as Diamond } from "../../assets/AccountDetails/diamond.svg";
import { Check, X } from "react-feather";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { AuthContext } from "../../Context/AuthContext";
import { DataContext } from "../../Context/DataContext";

const AccountDetails = () => {
  const { transitionTo } = useScreenTransition();

  const { signedIn } = useContext(AuthContext);
  const { userData, order, setOrder } = useContext(DataContext);

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && (userData.accountType === "personal" || !userData.teamId)) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal" })
      );
      setOrder((q) => ({ ...q, type: "personal" }));
    } else if (
      signedIn &&
      (userData.accountType === "business" || userData.teamId)
    ) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business" })
      );
      setOrder((q) => ({ ...q, type: "business" }));
    }
  };

  const personalFeatures = [
    { text: "Create Orders & Quotes", enabled: true },
    { text: "4-Hour Delivery", enabled: true },
    { text: "Chat in Orders", enabled: true },
    { text: "Manual Payment For Each Order", enabled: true },
    { text: "Team Members", enabled: false },
    { text: "Сlient Names in Orders", enabled: false },
    { text: "White-Labeled Translations", enabled: false },
  ];

  const businessFeatures = [
    { text: "Create Orders & Quotes", enabled: true },
    { text: "4-Hour Delivery", enabled: true },
    { text: "Chat in Orders", enabled: true },
    { text: "Flexible & Automated Billing", enabled: true },
    { text: "Team Members", enabled: true },
    { text: "Сlient Names in Orders", enabled: true },
    { text: "White-Labeled Translations", enabled: true },
  ];
  return (
    <div
      className="overflow-hidden rounded-4xl bg-cover bg-center mt-5  md:p-8 p-4"
      style={{ backgroundImage: `url(${BackGround})`, backgroundSize: "cover" }}
    >
      <div className="mt-20 flex flex-col gap-6 items-center">
        <h2 className="font-secondary font-medium md:text-5xl text-4xl text-white uppercase text-center">
          Personal and Business Account
        </h2>
        <p className="text-[#BDC1C9]  text-base text-center xl:w-2/5 w-full xl:px-12 px-2">
          We support businesses of all sizes and individuals across dozens of
          industries with streamlined workflows that ensure accurate, on-time
          translations—every time.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-16">
        <div className="border border-[#38465C] rounded-[20px] p-4">
          <div className="bg-[#F46350] rounded-[12px] lg:p-8 p-4 ">
            <div className="flex gap-4 items-center justify-between">
              <h3 className="font-secondary font-medium md:text-4xl text-3xl text-white">
                Personal
              </h3>

              <User className="h-10 w-10" />
            </div>
            <p className="text-white text-base mt-4 w-full">
              Perfect for one-time or occasional translation needs. Easily
              upload your documents, track progress, chat directly with our
              team, and receive certified translations right to your inbox—fast
              and hassle-free.
            </p>
          </div>

          <div>
            <ul className="flex gap-4 flex-col md:p-8 px-4 py-8">
              {personalFeatures.map((feature, index) => (
                <li
                  key={index}
                  className="text-white text-base flex gap-4 items-center justify-start"
                >
                  <span
                    className={`${
                      feature.enabled ? "bg-primary" : "bg-[#F46350]"
                    } rounded-full overflow-hidden flex justify-center items-center p-0.5`}
                  >
                    {feature.enabled ? (
                      <Check className="h-4 w-4 text-white" />
                    ) : (
                      <X className="h-4 w-4 text-white" />
                    )}
                  </span>
                  {feature.text}
                </li>
              ))}
            </ul>

            <button
              className="w-full py-2 border-white text-white border rounded-full text-center"
              onClick={(e) => gotoOrder(e)}
            >
              Create Order
            </button>
          </div>
        </div>

        <div className="border border-[#38465C] rounded-[20px] p-4">
          <div className="bg-[#7245ED] rounded-[12px] lg:p-8 p-4 ">
            <div className="flex gap-4 items-center justify-between">
              <h3 className="font-secondary font-medium md:text-4xl text-3xl text-white">
                Business
              </h3>

              <Diamond className="h-10 w-10" />
            </div>
            <p className="text-white text-base mt-4 w-full">
              Built for law firms, schools, clinics, and organizations managing
              multiple clients. Add team members, track orders by client, and
              streamline your translation workflow with flexible billing and
              same-day delivery.
            </p>
          </div>

          <div>
            <ul className="flex gap-4 flex-col md:p-8 px-4 py-8">
              {businessFeatures.map((feature, index) => (
                <li
                  key={index}
                  className="text-white text-base flex gap-4 items-center justify-start"
                >
                  <span
                    className={`${
                      feature.enabled ? "bg-primary" : "bg-[#F46350]"
                    } rounded-full overflow-hidden flex justify-center items-center p-0.5`}
                  >
                    {feature.enabled ? (
                      <Check className="h-4 w-4 text-white" />
                    ) : (
                      <X className="h-4 w-4 text-white" />
                    )}
                  </span>
                  {feature.text}
                </li>
              ))}
            </ul>

            <button
              className="w-full py-2 border-white text-white border rounded-full text-center"
              onClick={(e) => gotoOrder(e)}
            >
              Create Order
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
